export default __webpack_public_path__ + "static/media/026-captain.2434135e.png";